import { GlossaryItem } from './glossary';

export const SHARED_GLOSSARY = {
  adSpend: {
    label: 'Ad Spend',
    definition:
      'The budget of the advertising campaign for the given flight dates, as provided by the advertiser.',
  },
  campaignEndDate: {
    label: 'Campaign End Date',
    definition:
      'The final date that an advertising campaign serves impressions. Also known as Flight End Date.',
  },
  campaignStartDate: {
    label: 'Campaign Start Date',
    definition:
      'The first date an advertising campaign serves impressions. Also known as Flight Start Date.',
  },
  confidenceLevel: {
    label: 'Confidence Level',
    definition:
      'The confidence percentage under the lift estimates in LCI refers to the confidence interval of a statistical test that the lift number is greater than 0 (no lift). It is a function of the lift percentage as well as the sample size of the exposed.',
  },
  dimension: {
    label: 'Dimension',
    definition:
      'A specific subset of data planned for tracking during a campaign. Dimensions are used to gain granular insight into campaign performance for optimization. InMarket provides Multi-Touch Attribution metrics within each dimension. Examples of a dimension are audience, publisher, and creative.',
  },
  dimensionValue: {
    label: 'Dimension Value',
    definition:
      'A segment of a dimension (category) of measurement. Example: Audience A and Audience B are dimension values of the Audience dimension. Dimension values are the basis for comparing performance across a variety of factors in a measurement report. InMarket provides Multi-Touch Attribution metrics for each dimension value.',
  },
  flightDates: {
    label: 'Flight Dates',
    definition:
      'The date range of an advertising campaign during which impressions are served, consisting of Campaign Start Date and Campaign End Date.',
  },
  impression: {
    label: 'Impression',
    definition:
      'An ad unit served to a user. An impression can be served on various media channels, such as a mobile device (mApp and mWeb), desktop, website, direct mail, out-of-home, TV, audio, etc.',
  },
  incrementalReturnOnAdSpend: {
    label: 'Incremental Return on Ad Spend (IROAS)',
    definition:
      'The estimated incremental dollar amount of ad spend return across the measurement period.',
  },
  incrementalSales: {
    label: 'Incremental Sales',
    definition:
      'Sales Attribution related to exposed users matched to an unexposed control group, can thereby be attributed to the effects of advertising. Measures the additional dollars gained in-store and online due to increased visits and differences in sales rate.',
  },
  incrementalSalesLift: {
    label: 'Incremental Sales Lift',
    definition:
      'Measures the percentage increase in lift in the rate of sales by the exposed compared to the control.',
  },
  measurementEndDate: {
    label: 'Measurement End Date',
    definition:
      'The date through which impression and visit data are used for a measurement report. This date is the same as the Report Date.',
  },
  measurementStartDate: {
    label: 'Measurement Start Date',
    definition: 'The first date of the Measurement Period.',
  },
  multiTouchAttribution: {
    label: 'Multi-Touch Attribution (MTA)',
    definition:
      "Whereas single-touch attribution ignores cross exposure to multiple ad-types when measuring advertising effectiveness, Multi-Touch Attribution (MTA), used in InMarket's LCI® Measurement, recognizes and controls for cross exposure to multiple ad types, thereby providing a more accurate and realistic assessment of the effectiveness of advertising campaigns. MTA analyzes all different ad types collectively and simultaneously rather than individually, as with single-touch attribution. By providing measurement of advertising effectiveness as campaigns are actually delivered (users are almost always exposed to multiple advertising touchpoints before any visit or conversion), MTA provides more accurate and actionable results than single-touch attribution.",
  },
  penetration: {
    label: 'Penetration',
    definition:
      'The percentage of users who made at least one purchase during the measurement period',
  },
  returnOnAdSpend: {
    label: 'Return on Ad Spend (ROAS)',
    definition:
      'The estimated dollar amount of ad spend return across the measurement period.',
  },
  salesRate: {
    label: 'Sales Rate',
    definition:
      'The average dollar amount purchased per user during the measurement period across all users.',
  },
  transactionRate: {
    label: 'Transaction Rate',
    definition:
      'The average number of transactions per user who transacted during the measurement period',
  },
  uniqueUser: {
    label: 'Unique User',
    definition:
      'Rather than counting just every unique device exposed to your advertising, InMarket de-duplicates devices that belong to the same person. Results provided on the level of unique users are more trustable than those on the level of unique devices, as they count individual persons rather than individual devices.',
  },
  usersMatchedForAttribution: {
    label: 'Users Matched For Attribution',
    definition:
      'Exposed users that have been matched to our visit universe to calculate Incremental Lift.',
  },
} as const satisfies Record<string, GlossaryItem>;
